import React, { useEffect, useMemo, useState } from "react";

import redDotIcon from "./icons/RedDotIcon.svg";
import yellowDotIcon from "./icons/YellowDotIcon.svg";
import greenDotIcon from "./icons/GreenDotIcon.svg";
import blackDotIcon from "./icons/BlackDotIcon.svg";

import { observer } from "mobx-react-lite";
import { useStores } from "index";

const UpdateTimer = observer(() => {
  const { systemStore } = useStores();

  const [displayText, setDisplayText] = useState<string>("");
  const [icon, setIcon] = useState<string>(blackDotIcon);

  const icons = [greenDotIcon, yellowDotIcon, redDotIcon, blackDotIcon];
  const iconMinTimers = [10, 30, 60];

  const updateInterval = 3; // Check after this many sec if text and/or icon need change.

  const updateTimer = () => {
    const currentTime = new Date();
    const minutesSincePull = Math.floor(
      (currentTime.getTime() - systemStore.lastUpdatedDate.getTime()) /
        (1000 * 60)
    );
    const timeText: string =
      minutesSincePull >= 1 ? minutesSincePull.toString() : "less then 1";
    const correctIcon =
      minutesSincePull < iconMinTimers[0]
        ? icons[0]
        : minutesSincePull < iconMinTimers[1]
        ? icons[1]
        : minutesSincePull < iconMinTimers[2]
        ? icons[2]
        : icons[3];
    if (timeText !== displayText || correctIcon !== icon) {
      setDisplayText("Dashboard: updated " + timeText + "m ago");
      setIcon(correctIcon);
    }
  };

  const [lastInterval, setLastInterval] = useState<NodeJS.Timeout | null>();

  useEffect(() => {
    updateTimer();
    var interval = setInterval(updateTimer, 1000 * updateInterval);

    //Cleanup after last interval, and remebering the last interval before
    lastInterval && clearInterval(lastInterval);
    setLastInterval(interval);
  }, []);

  return (
    <div className="updateBox">
      <p className="updateText">
        <img src={icon} alt="" />
        {displayText}
      </p>
    </div>
  );
});

export default UpdateTimer;
